import {
  OPERATORS_ROUTE,
  APPLICATIONS_ROUTE,
  BANK_ACCOUNTS_ROUTE,
  CASH_PAYMENT_ROUTE,
  DISTRIBUTORS,
  DEVELOPERS_ROUTE,
  ECOMMERCE_ROUTE,
  EXPRESS_CHARGE_ROUTE,
  INVOICES_ROUTE,
  PAYMENT_BUTTON_ROUTE,
  PORTAL_LAYOUT_ROUTE,
  READER_ROUTE,
  RESUME_ROUTE,
  SALES_POINT_ROUTE,
  SPEI_TRANSFER_ROUTE,
  SRPAGO_CARD_ROUTE,
  TRANSACTIONS_ROUTE,
  TRANSFER_BETWEEN_USERS_ROUTE,
} from "./portalPaths";

import {
  Operators,
  Applications,
  BankAccounts,
  CashPayment,
  Distributors,
  ExpressCharge,
  Invoices,
  PaymentButton,
  Reader,
  Resume,
  SpeiTransfer,
  SrPagoCard,
  Transactions,
  TransferBetweenUsers,
} from "../../components/modules/Portal";

import {
  OperatorsIcon,
  ApplicationsIcon,
  BanckAccountsIcon,
  BotonDePagoIcon,
  CashPaymentIcon,
  CobroExpressIcon,
  DistributorsIcon,
  InvoicesIcon,
  ReaderIcon,
  ResumeIcon,
  SpeiTransferIcon,
  SrPagoCardIcon,
  TransactionsIcon,
  TransfersBetweenUsersIcon,
} from "../../components/common/SrIcon";

import roles from "../../constants/roles.constant";

const { OWNER, OPERATOR } = roles;

// It was necessary to return a function instead of a single object because some
// components appeared as null since they were loaded after the object declaration.
const portalRoutesConfig = () => ({
  path: PORTAL_LAYOUT_ROUTE,
  children: [
    {
      path: "",
      label: "",
      children: [
        {
          path: RESUME_ROUTE,
          label: "menu.resume",
          icon: ResumeIcon,
          component: Resume,
          authorizedRoles: [OWNER],
        },
        {
          path: TRANSACTIONS_ROUTE,
          label: "menu.transactions",
          icon: TransactionsIcon,
          component: Transactions,
          authorizedRoles: [OWNER, OPERATOR],
        },
        {
          path: DISTRIBUTORS,
          label: "menu.distributors",
          icon: DistributorsIcon,
          component: Distributors,
          permissionKey: "/codes",
          authorizedRoles:
            process.env.REACT_APP_ENABLE_DISTRIBUTORS === "true" ? [OWNER] : [],
        },
        {
          path: SRPAGO_CARD_ROUTE,
          label: "menu.srPagoCard",
          icon: SrPagoCardIcon,
          component: SrPagoCard,
          authorizedRoles: [OWNER],
        },
        {
          path: BANK_ACCOUNTS_ROUTE,
          label: "menu.bankAccounts",
          icon: BanckAccountsIcon,
          component: BankAccounts,
          authorizedRoles: [OWNER],
        },
        {
          path: OPERATORS_ROUTE,
          label: "menu.operators",
          icon: OperatorsIcon,
          component: Operators,
          authorizedRoles: [OWNER],
        },
        {
          path: INVOICES_ROUTE,
          label: "menu.invoices",
          icon: InvoicesIcon,
          component: Invoices,
          authorizedRoles: [OWNER],
        },
      ],
    },
    {
      path: SALES_POINT_ROUTE,
      label: "menu.salesPoint",
      children: [
        {
          path: READER_ROUTE,
          label: "menu.reader",
          icon: ReaderIcon,
          component: Reader,
          authorizedRoles: [OWNER],
        },
        {
          path: CASH_PAYMENT_ROUTE,
          label: "menu.cashPayment",
          icon: CashPaymentIcon,
          component: CashPayment,
          authorizedRoles: [OWNER, OPERATOR],
        },
        {
          path: SPEI_TRANSFER_ROUTE,
          label: "menu.speiTransfer",
          icon: SpeiTransferIcon,
          component: SpeiTransfer,
          authorizedRoles: [OWNER],
        },
      ],
    },
    {
      path: ECOMMERCE_ROUTE,
      label: "menu.eCommerce",
      children: [
        {
          path: EXPRESS_CHARGE_ROUTE,
          label: "menu.cobroExpress",
          icon: CobroExpressIcon,
          component: ExpressCharge,
          authorizedRoles: [OWNER, OPERATOR],
          permissionKey: "/payment/ecommerce",
        },
        {
          path: PAYMENT_BUTTON_ROUTE,
          label: "menu.botonDePago",
          icon: BotonDePagoIcon,
          component: PaymentButton,
          authorizedRoles: [OWNER, OPERATOR],
          permissionKey: "/payment/ecommerce",
        },
        {
          path: TRANSFER_BETWEEN_USERS_ROUTE,
          label: "menu.transfersBetweenUsers",
          icon: TransfersBetweenUsersIcon,
          component: TransferBetweenUsers,
          authorizedRoles: [OWNER],
          permissionKey: "ecommTransferBtwUsrs",
        },
      ],
    },
    {
      path: DEVELOPERS_ROUTE,
      label: "menu.developers",
      children: [
        {
          path: APPLICATIONS_ROUTE,
          label: "menu.applications",
          icon: ApplicationsIcon,
          component: Applications,
          authorizedRoles: [OWNER],
          permissionKey: "/client/application",
        },
      ],
    },
  ],
});

export default portalRoutesConfig;
